<template>
  <div>
    <div ref="printBox">
      <!-- 报告头信息 -->
      <ContentTitle ref="contentTitle" :data-map="dataMap" :home-stat="homeStat" :score="score"></ContentTitle>
      <ContentBoard ref="contentBoard" :data-map="dataMap" :home-stat="homeStat" :score="score"
                    :boardData="boardData"></ContentBoard>
      <ContentDataReport ref="contentDataReport" :home-sta="homeStat" :stat="stat" :bar-data="barData"
                         :score="score" :data-map="dataMap"></ContentDataReport>
      <ContentDetail ref="content_detail" :data-map="dataMap"></ContentDetail>
    </div>
  </div>
</template>

<script>

import ContentTitle from './content-title.vue'
import ContentBoard from './content-board.vue'
import ContentDetail from './content-detail.vue'
import ContentDataReport from './content-data-report.vue'
import html2canvas from 'html2canvas'
import printJS from 'print-js'
import 'print-js/dist/print.css'

export default {
  name: 'report-content',
  components: {
    html2canvas,
    printJS,
    ContentTitle,
    ContentBoard,
    ContentDetail,
    ContentDataReport
  },
  props: {
    stat: Object,
    homeStat: Object,
    dataMap: Object,
    score: Object,
    barData: Object,
    boardData: Object
  },
  mounted () {
    console.log(this.homeStat)
  }
}
</script>
